import { IUpdateBillingCycleEntity } from '../entitites/billing-cycle.entity';

export class BillingCycleUpdateDto {
  readonly billing_unit_code:
    | 'monthly'
    | 'yearly'
    | 'half-yearly'
    | 'quarterly'
    | 'mixed';

  constructor(entity: IUpdateBillingCycleEntity) {
    this.billing_unit_code = entity.cycle;
  }
}
